<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="r18-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">年齢確認</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="small mb-3">
                        <div>R18コンテンツには18歳未満の方に好ましくない内容が含まれます。</div>
                        <div>18際未満の方の閲覧をお断りしています。</div>
                    </div>
                    <button class="btn btn-outline-primary btn-block" @click="close()">
                        <i class="fas fa-eye-slash"></i>
                        １８歳未満（高校生以下）
                    </button>
                    <button class="btn btn-outline-danger btn-block" @click="accept()">
                        <i class="fas fa-eye"></i>
                        １８歳以上
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        close() {
            $("#r18-modal").modal("hide");
        },
        accept() {
            this.$store.dispatch("acceptR18");
            this.close();
        }
    }
}
</script>